import { IconsProps } from 'Icons/types'
import React from 'react'

const ArrowRight = ({ fill = '#0d0d0d' }: IconsProps) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.46965 0.469671C7.76255 0.176777 8.23742 0.176776 8.53031 0.469669L15.5303 7.46965C15.671 7.61031 15.75 7.80107 15.75 7.99998C15.75 8.1989 15.671 8.38966 15.5303 8.53031L8.53031 15.5303C8.23742 15.8232 7.76255 15.8232 7.46965 15.5303C7.17676 15.2374 7.17676 14.7626 7.46965 14.4697L13.1893 8.74998H1C0.585786 8.74998 0.25 8.4142 0.25 7.99998C0.25 7.58577 0.585786 7.24998 1 7.24998H13.1893L7.46966 1.53033C7.17676 1.23744 7.17676 0.762565 7.46965 0.469671Z'
        fill={fill}
      />
    </svg>
  )
}

export default ArrowRight
